import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useState, useEffect } from 'react';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const useFormattedDate = (timestamp, dateFormat = "DD/MM/YYYY", timeFormat) => {
    const [formattedDate, setFormattedDate] = useState("");
    const updateDate = () => {
        setFormattedDate(dayjs(timestamp).format(dateFormat + (timeFormat ? " " + timeFormat : "")));
    };
    useEffect(updateDate, [timestamp, dateFormat, timeFormat]);
    return formattedDate;
};

export { useFormattedDate as default };
//# sourceMappingURL=useDateTimeFormat.js.map
